import { z } from "zod";
import { isArray } from "lodash";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

const auditEventSelectedDataSchema = z.object({
	selectionMetaData: z.object({
		allScannedIdentifiers: z
			.any()
			.transform((data) => (isArray(data) ? data : []))
			.pipe(z.array(z.string())),
		totalAvailablePackagingSolutions: z.number(),
		configuredPipelineSteps: z.array(z.string()),
		cartonsBeforeFilters: z.record(z.string(), z.number()),
		cartonsAfterFilters: z.record(z.string(), z.number()),
	}),
});

export const auditEventSelectedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Selected),
	data: auditEventSelectedDataSchema,
});

export type AuditEventSelected = z.infer<typeof auditEventSelectedSchema>;
